<template>
<div style="height:100vh; overflow-y: scroll;">
<div class="outer">
<h1 style="text-align: center;margin-bottom: 20px">《心理亦笙》医生用户注册协议</h1>
<p><strong></strong><strong></strong></p>
<p>&nbsp;</p>
<p style="text-indent: 2rem">由美国的精神科专家徐明医生和资深IT专家徐建平先生带领的亦笙信息技术（深圳）有限公司团队共同研发了神经、精神、心理咨询线上服务平台 ———《心理亦笙》。该平台以美国的精神科医生、神精科医生和内科医生团队为基础，同时吸纳中国的神经、精神和心理方面的专家学者参与，为中国患者和在美国的华人及留学生提供专业的心理辅导与专业帮助！同时，这个平台也给美中业界同行们提供最新的学术研究新闻，为中国同行提供便利高效的精神学药库等其他方面的服务。欢迎您加盟我们团队，为患者服务！</p>
<p style="text-indent: 2rem">《心理亦笙》一个完全由医生对患者自主管理的医生工作室；一个充分尊重医生权益，有收益的医生咨询工作室。</p>
<p>&nbsp;</p>
<p style="text-indent: 2rem">任何注册的医生用户应仔细阅读本注册协议，在阅读本协议后，选择继续注册使用平台行为的医生用户被认为同意并接受本注册协议。</p>
<p>&nbsp;</p>
<p class="bold">一、内容</p>
<p>注册医生用户作为心理咨询管理平台《心理亦笙》的专业精神科、神精科和相关内科心理咨询专家，在平台的网站（<a target="_blank" href="https://www.neuropsychstudio.com">www.neuropsychstudio.com</a>）上创建并管理咨询的个人工作室网站，提供相关的心理咨询服务。</p>
<p>&nbsp;</p>
<p class="bold">二、时间</p>
<p>合作期限为自注册日起，直至自行终止或《医生用户注册协议》第七条的协议终止条款。</p>
<p>&nbsp;</p>
<p class="bold">三、方式</p>
<p>1、注册医生用户可根据自己的工作情况确定在《心理亦笙》平台上的可预约咨询时间，该具体时间可由医生随时变更，但应当提前<u>48小时</u>在其个人工作室网站上公布。</p>
<p>2、注册医生用户可以根据自身和所处地区的情况设定收费标准，收费可调范围从100元/次至1000元/次，每次限定时间为20分钟；</p>
<p>&nbsp;</p>
<p class="bold">四、权利和义务</p>
<p>1、注册医生用户应当提供<strong>《医师执业证书》</strong>和<strong>《医师资格证书》</strong>或<strong>《心理咨询师资格证》</strong>以通过《心理亦笙》平台系统的资格审核，否则您注册的账号在线预约和咨询功能不能被开通。注册医生用户在提供心理辅导和咨询过程中的任何交流，不能作为临床诊断及医疗的依据，只是一种健康咨询行为，不能取代患者在医院时的诊疗行为。注册医生在与患者心理咨询过程中必须对自己的言行负责，不得诱导或欺骗患者。</p>
<p>2、《心理亦笙》管理平台负责建立以注册医生用户个人名义建立的心理咨询标准工作室网站，《心理亦笙》平台可以为注册医生用户进行个人工作室网站的装修、信息发布或图片美工处理等提供帮助。</p>
<p>3、注册医生用户可以参与其个人工作室网站的设计，并配合《心理亦笙》后台管理与技术开发，处理相应平台运行过程中所发生的问题，提出意见或建议，以改善平台的建设，提升我们的服务。</p>
<p>4、《心理亦笙》平台对涉及《心理亦笙》网站内的页面设计、著作权、专利权、商标权等全部知识产权及各平台形成的所有数据等享有完全的权利。</p>
<p>5、未经《心理亦笙》管理平台同意，注册医生用户不得擅自以复制、转移、转让或以其他任何方式将涉及《心理亦笙》管理平台的知识产权、数据等用于本协议规定以外的营利或非营利用途，亦不得将自己的注册账号私自向任何第三人批露。</p>
<p>&nbsp;</p>
<p class="bold">五、收益分配</p>
<p>1、咨询服务费将以7:3原则由《心理亦笙》平台与注册医生用户分配，即注册医生用户获得咨询服务费用的70%，《心理亦笙》管理平台获得咨询服务费用的30%用于运营和维护平台、客服保障等管理费用的支出。</p>
<p>2、医生工作室主页广告的发布权属于《心理亦笙》平台，如果注册医生用户有渠道获得到的广告业务，注册医生用户将可获得广告费收入的50%作为奖励。</p>
<p>3、双方各自负担自己的税收，注册医生用户税款需由《心理亦笙》平台代扣代缴的，《心理亦笙》平台依法代扣代缴税款。</p>
<p>4、《心理亦笙》平台在每月5日结算一次，将完税后服务费分配金额转入注册医生用户提供的银行账户（平台客服会对接每位医生）。</p>
<p>5、如遇注册医生用户与咨询者有争议的，《心理亦笙》平台有权冻结、暂不分配争议所涉及的服务费用，待争议完全解决后再行处置。</p>
<p>6、注册医生用户如对甲方转账数额有疑义，应当及时向《心理亦笙》平台书面提出，《心理亦笙》平台核查确认后给予书面回复并作相应处理。</p>
<p>&nbsp;</p>
<p class="bold">六、保密义务</p>
<p>1、注册医生用户合作期间的保密义务</p>
<p>(1) 注册医生用户在协议期间，必须遵守《心理亦笙》平台规定的任何成文或不成文的保密规章、制度（包括《心理亦笙》规定的条款），履行与相应的保密义务；</p>
<p>(2) 未经《心理亦笙》平台同意不得以泄露、告知、公布、发布、出版、传授、转让或者其他任何方式使任何第三方(包括按照保密制度规定不得知悉该项秘密的《心理亦笙》平台其他成员)知悉属于《心理亦笙》平台或者属于他人但《心理亦笙》平台承诺有保密义务的技术秘密或其他商业秘密信息；</p>
<p>(3) 注册医生用户有义务保守患者的个人及其病情信息的业务，情节严重的，《心理亦笙》平台将保留司法诉讼的权利。</p>
<p>2、协议终止之后的保密义务</p>
<p>双方同意，协议终止之后仍对其在合作期间接触、知悉的属于《心理亦笙》平台或者虽属于第三方但《心理亦笙》平台承诺有保密义务的技术秘密和其他商业秘密信息，承担如同协议期间一样的保密义务和不擅自使用有关秘密信息的义务，而无论因何种原因终止合作。</p>
<p class="bold">七、协议终止</p>
<p>双方可协商一致提前终止本协议，其他终止情形适用乙方在《心理亦笙》上注册时的《医生用户注册协议》中的规定。</p>
<p>&nbsp;</p>
<p class="bold right">亦笙信息技术（深圳）有限公司</p>
<p class="bold right">2021-01-01</p>

</div>
	<footerCommon></footerCommon>
</div>
</template>

<script>
export default {
    name: "agreementDoctor",
    components: {
        'footerCommon': () => import('../footerCommon'),
    },
    mounted() {
        this.$router.app.$children[0].$data.type = 'none';
    }
}
</script>

<style lang="scss" scoped>
.outer{
	padding: 40px;
	p.bold{font-weight: bold}
	p.right{text-align: right;}
	p{
		text-indent: 2rem;
		font-size: 14px;
		color: #434343;
		line-height: 2;
		a{
			text-decoration: underline;
		}
	}
}
</style>